import { render, staticRenderFns } from "./PurchaseCardLoading.vue?vue&type=template&id=7770f11b"
import script from "./PurchaseCardLoading.vue?vue&type=script&lang=ts"
export * from "./PurchaseCardLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports